module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAMAAABEH1h2AAAAQlBMVEUAAAD4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpH4dpGVfZqwAAAAFXRSTlMAzDvEri4L85yR481vZU8yHAPrhR5TH0bpAAAAsUlEQVRIx+3VywrDIBCF4WMSzf3W9rz/qzaLhlC01JkiSPFf+4HjwkGppKimsPqNU1xmvEJkVZAjuux5Q7I6J23EfGtfqiHbTcwxkbTAg+QEOd9Hsgfu5LgrOFayde5Grghyc9YFOXpynskeX7gJczfQGA5OybHwaIGKk1efn87+xuFz/1xirr/8X86u4n7pufCj9rmozLhqQV9cXipujgpXcxurrc9FZcY7qe5QKsl7AhGyO69dxT9NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/comboIcon.png
// module id = AN1M
// module chunks = 1